import React from "react";
import { formatedPrice } from "Utils/utils";

function RangeInput({ onChange = () => {}, step = 50, value = 0, min = 0, max = 1000, unit = "", className = "" }) {
	return (
		<>
			<input onChange={(e) => onChange(e.target.value)} value={value} type="range" className={`w-full ${className}`} min={min} max={max} />
			<div className="flex items-start justify-between text-xs text-secondary">
				<div>
					{unit} {formatedPrice(min?.toFixed())}
				</div>
				<div>
					{unit} {formatedPrice(max?.toFixed())}
				</div>
			</div>
		</>
	);
}

export default RangeInput;
